import * as Sentry from "@sentry/react";

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content;
const environment = document.querySelector('meta[name="sentry-environment"]')?.content;
const release = document.querySelector('meta[name="sentry-release"]')?.content;
const sentryEnabled = dsn && environment !== 'development';

if (sentryEnabled) {
  Sentry.init({
    dsn,
    environment,
    release,
    sendDefaultPii: true,

    integrations: [
      Sentry.browserTracingIntegration(),
      // Replay is deferred below to avoid forced reflows during initial render
    ],

    // Capture all traces in dev, tune down in production via SENTRY_TRACES_SAMPLE_RATE
    tracesSampleRate: 1.0,

    // Session Replay: capture 10% of sessions, 100% of sessions with errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Release health: track user sessions for crash-free metrics
    autoSessionTracking: true,

    // Propagate traces to our own backend(s) for distributed tracing
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/[^/]*\.allspark\.build/,
    ],
  });

  // Defer Replay integration to avoid 50-75ms forced reflows (rrweb serializeElementNode)
  // during initial page render. Load after the page is idle instead.
  const addReplay = () => {
    Sentry.addIntegration(Sentry.replayIntegration());
  };
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(addReplay);
  } else {
    setTimeout(addReplay, 3000);
  }
}
